<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">{{ $t('forms') }} </h4>
    </div>
    <div class="col-md-12 card">

      <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="createFormBuilder">
          <i class="fa fa-plus"></i> {{ $t('new_form') }}
        </p-button>
      </div>

      <div class="card-body">

        <div class="row">
           <div class="col-sm-6">
            <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                placeholder="Search"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              >
              </fg-input>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <el-table
            v-loading="loading"
            :element-loading-text="$t('loading_data') + '...'"
            class="table-bordered"
            :data="paginated"
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
            <el-table-column
              :min-width="120"
              fixed="right"
              class-name="td-actions text-center"
              :label="$t('actions')"
            >
              <template slot-scope="props">
                <p-button
                  type="secondary"
                  size="sm"
                  title="View Farmers Responses"
                  icon
                  @click="handleUser(props.$index, props.row)"
                >
                  <i class="fa fa-user"></i>
                </p-button>
                <p-button
                  type="primary"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="card-footer">
        <paginate :pagination="pagination" :metadata="metaData" :allData="getForms"></paginate>
      </div>

    </div>

    <!-- Add Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('choose_page_template') }}</h4>
      <form>
        <fg-input>
          <el-select
            size="large"
            class="select-primary"
            filterable
            clearable
            v-model="ngoSelected"
            :placeholder="$t('select_ngo')"
          >
            <el-option
              class="select-primary"
              v-for="(ngo, index) in ngoOptions"
              :key="index"
              :label="ngo"
              :value="ngo"
            ></el-option>
          </el-select>

          <el-select
            size="large"
            class="select-primary"
            filterable
            clearable
            v-model="countrySelected"
            :placeholder="$t('select_country')"
          >
            <el-option
              class="select-primary"
              v-for="(country, index) in countryOptions"
              :key="index"
              :label="country"
              :value="country"
            ></el-option>
          </el-select>


        </fg-input>
      </form>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal"
            >{{ $t('cancel') }}</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click="createFormBuilder">{{ $t('continue') }}</p-button>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Paginate from '../../../UIComponents/Paginate.vue';

import Modal from "src/components/UIComponents/Modal.vue";
import Con from "@/util/helpers.js";

import Resource from "@/util/Api/resource.js";
const FormResource = new Resource("surveys");
const deleteFormResource = new Resource("surveys");
const CategoryResource = new Resource("category");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Modal,
    Paginate
  },
  computed: {
    queriedData() {
        return Con.filterData(this.tableData, this.searchQuery);
    },

    paginated(){
        return Con.paginateData(this.queriedData, this.pagination);
    },
  },
  data() {
    return {
      pagination: {
          perPage: 10,
          perPageOptions: [10, 20, 30, 60, 500, 1000],
          currentPage:1,
          nextPage:'',
          prevPage:'',
          total:'',
          from:'',
          to:'',
          page:'',
      },
      metaData: {
         meta:'',
         links:''
      },
      searchQuery: "",
      categories:[],
      ngos:[],
      ngoOptions:[],
      countries:[],
      countryOptions:[],
      countrySelected:"",
      ngoSelected:"",
      form: {
        id: ""
      },

      modals: {
        classic: false
      },
      propsToSearch: ["title"],

      tableColumns: [
        {
          prop: "title",
          label: "Form Title",
          minWidth: 300
        },{
          prop: "ngo",
          label: "Ngo",
          minWidth: 300
        }
      ],

      tableData: [],
      loading: false
    };
  },
  created() {
    this.getForms();
    this.getContentCategory();
  },
  methods: {
    // show message dialog
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    async getContentCategory() {
      this.isLoading = true;
      await CategoryResource.list({})
      .then(response => {
          this.categories = response.data
          this.dropDowns();
          this.loading = false;
        })
        .catch(error => {
          console.log("error occured");
        });
    },

    dropDowns(){
      this.categories.forEach(val=>{
        if(val.name==='NGOs'){
          this.ngos = val.children
          this.ngos.forEach(ngo=>{
            this.ngoOptions.push(ngo.name)
          })
        }
        else if (val.name==='Countries & Communities'){
          this.countries = val.children
          this.countries.forEach(country=>{
            this.countryOptions.push(country.name)
          })
        }
      })
    },

    handleCreateModal() {
      this.modals.classic = true;
    },

    handleCloseModal() {
      this.modals.classic = false;
    },

    // deleting form template
    handleDelete(index, row) {
      this.$confirm("Are you sure you want to delete this form?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-danger",
        confirmButtonClass: "btn-primary",
        type: "warning"
      })
        .then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            deleteFormResource
              .deleteWithGet(row.id)
              .then(response => {
                this.tableData.splice(indexToDelete, 1);
                this.showAlertMessage(
                  this.$t("form_template_deleted_successfully"),
                  "success"
                );
              })
              .catch(error => {
                console.log(error.response.data.error);
              });
          }
        })
        .catch(() => {});
    },

    handleEdit(index, row) {
        this.$router.push({ name: "EditForm", params: { data: row } });
    },

    handleUser(index, row) {
      this.$router.push({ name: "UserForm", params: { id: row.id } });
    },

    // get all form template
    async getForms(page_url) {
      this.loading = true;
      if(page_url) {
        page_url = Con.splitStringLinks(page_url);
      }
      await FormResource.list(page_url)
      .then(response => {
          this.loading = false;

          if(this.tableData.length > 0){
            this.tableData = [...response.data.data, ...this.tableData];
          } else {
            this.tableData = response.data.data;
          }

          this.metaData.meta = response.data.meta;
          this.metaData.links = response.data.links;

        }).catch(error => {
          console.log('error', error);
          this.loading = false;
      });
    },

    createFormBuilder() {
       this.$router.push({ name: "CreateForm" });
    }
  }
};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
a.custom-link {
  background-color: #2c2c2c;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
}
a.custom-link:hover {
  background-color: #6bd098;
  color: white;
}
</style>
